export function preventEventBubbling(event) {
  if (!event) return;
  event.preventDefault();
  event.stopPropagation();
  if (!event.nativeEvent) return;
  event.nativeEvent.stopImmediatePropagation();
}
